// extracted by mini-css-extract-plugin
module.exports = {"container":"RadioImage_container__1iZyo","selected":"RadioImage_selected__3iird","label":"RadioImage_label__2SALg"};